
import NumberFormat from "react-number-format";

export const Totales = ({ dataForm }) => {

    const {
        subtotal,
        descuento,
        monto_base,
        separacion_miles,
        separacion_decimales,
        simbolo,
        impuesto_nombre,
        total_impuesto,
        total_factura
    } = dataForm

    return (
        <div className='p-compras-box-totales'>
            <div className='row'>
                <div className='col'>
                    <h5>Montos Finales</h5>
                </div>
            </div>
            <div className='row mt-2 p-montos'>
                <div className='col-8 text-start'><span>Subtotal</span></div>
                <div className='col-4 text-end'>
                    <NumberFormat
                        value={parseFloat(subtotal)}
                        displayType={'text'}
                        thousandSeparator={separacion_miles}
                        decimalSeparator={separacion_decimales}
                        prefix={`${simbolo} `}
                        decimalScale={2}
                        fixedDecimalScale
                    />
                </div>
            </div>
            <div className='row p-montos'>
                <div className='col-8 text-start'><span>Descuento</span></div>
                <div className='col-4 text-end'>
                    <NumberFormat
                        value={parseFloat(descuento)}
                        displayType={'text'}
                        thousandSeparator={separacion_miles}
                        decimalSeparator={separacion_decimales}
                        prefix={`${simbolo} `}
                        decimalScale={2}
                        fixedDecimalScale
                    />
                </div>
            </div>
            <div className='row p-montos'>
                <div className='col-8 text-start'><span>Total base</span></div>
                <div className='col-4 text-end'>
                    <NumberFormat
                        value={parseFloat(monto_base)}
                        displayType={'text'}
                        thousandSeparator={separacion_miles}
                        decimalSeparator={separacion_decimales}
                        decimalScale={2}
                        prefix={`${simbolo} `}
                        fixedDecimalScale
                    />
                </div>
            </div>
            <div className='row p-montos'>
                <div className='col-8 text-start'><span className="text-capitalize">{impuesto_nombre || 'Impuesto'}</span></div>
                <div className='col-4 text-end'>
                    <NumberFormat
                        value={parseFloat(total_impuesto)}
                        displayType={'text'}
                        thousandSeparator={separacion_miles}
                        decimalSeparator={separacion_decimales}
                        prefix={`${simbolo} `}
                        decimalScale={2}
                        fixedDecimalScale
                    />
                </div>
            </div>
            <hr />
            <div className='row p-montos-2'>
                <div className='col-8 text-start'><span className="text-capitalize fw-bold">Total final</span></div>
                <div className='col-4 text-end'>
                    <NumberFormat
                        value={parseFloat(total_factura)}
                        displayType={'text'}
                        thousandSeparator={separacion_miles}
                        decimalSeparator={separacion_decimales}
                        prefix={`${simbolo} `}
                        decimalScale={2}
                        fixedDecimalScale
                    />
                </div>
            </div>
        </div>
    );
}
